import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './ui/CtaButton';
import { HERO_CHIPS, PRODUCT_IMAGE, STATS } from '../data/content';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink px-5 pb-16 pt-12 sm:px-8 sm:pb-24 sm:pt-16" data-id="element-97" data-mp="9kjv2k5raw1k">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-0 h-[520px] w-[720px] -translate-x-1/2 rounded-full bg-violeta-700/20 blur-[140px]" data-id="element-98" data-mp="4m8mecr76rkx" />
      <div className="relative mx-auto max-w-4xl text-center" data-id="element-99" data-mp="xanq434vpngy">
        <CtaButton href="#planes" size="md" className="mx-auto" data-id="element-100" data-mp="x8b85pz4fd3w">
          💜 QUIERO MI MEGAPACK AHORA
        </CtaButton>

        <p className="mt-10 font-display text-[10px] font-semibold uppercase tracking-mega text-violeta-300 sm:text-xs" data-id="element-101" data-mp="nc87ypntxojl">
          MegaPack Libertad y Sanación
        </p>

        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="mt-5 font-display text-5xl font-extrabold leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-7xl" style={{
        fontSize: "40px"
      }} data-id="element-102" data-mp="3czfkty10i55i">
          Recuperá tu vida.
          <span className="mt-2 block text-violeta-400" style={{
          fontSize: "36px"
        }} data-id="element-103" data-mp="39acyeqprnqu2">Sin volver atrás.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.15,
        ease: 'easeOut'
      }} className="mx-auto mt-10 max-w-2xl" data-id="element-104" data-mp="3e8mqgsg72bbg">
          <img src={PRODUCT_IMAGE} alt="MegaPack Libertad y Sanación: caja con los 6 tomos en PDF" className="mx-auto w-full drop-shadow-2xl" style={{
          width: "309px",
          height: "305px"
        }} data-id="element-105" data-mp="35aud3tu19dqp" />
        </motion.div>

        <p className="mt-8 font-display text-lg font-bold text-violeta-300 sm:text-xl" style={{
        fontSize: "13px"
      }} data-id="element-106" data-mp="2vglmjbokbuv6">
          El método N°1 para salir de una relación tóxica 
        </p>
        <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-violeta-100/75" style={{
        fontSize: "12px"
      }} data-id="element-107" data-mp="2ljz6d076lrzh">
          Sin improvisar sola. Sin repetir el ciclo. 6 Tomos + 6 Bonos con herramientas listas para
          usar hoy.
        </p>

        <ul className="mt-8 flex flex-nowrap items-center justify-center gap-1.5 sm:gap-2.5" data-id="element-108" data-mp="ibgnkzh73tmc">
          {HERO_CHIPS.map(chip => <li key={chip} className="whitespace-nowrap rounded-full border border-ink-line bg-ink-soft px-2.5 py-1.5 text-[10px] font-semibold text-violeta-100 sm:px-4 sm:py-2 sm:text-sm" data-id="element-109" data-mp="deyks55fe5cn">
              {chip}
            </li>)}
        </ul>

        <div className="mt-10" data-id="element-110" data-mp="11152jj4nizg2">
          <CtaButton href="#planes" data-id="element-111" data-mp="114kg2hiog0fd">💜 QUIERO MI MEGAPACK AHORA</CtaButton>
          <p className="mt-4 text-xs text-violeta-200/70 sm:text-sm" data-id="element-112" data-mp="x0uxq9slif2s">
            🛡️ Garantía 7 días · 💳 Mercado Pago · ⚡ Acceso inmediato
          </p>
        </div>

        <dl className="mx-auto mt-14 grid max-w-3xl grid-cols-2 gap-px overflow-hidden rounded-3xl border border-ink-line bg-ink-line sm:grid-cols-4" data-id="element-113" data-mp="3hqahikted3ix">
          {STATS.map(stat => <div key={stat.label} className="bg-ink-soft px-4 py-6" data-id="element-114" data-mp="21a4srt66ce4x">
              <dt className="sr-only" data-id="element-115" data-mp="269zk1xtv35qi">{stat.label}</dt>
              <dd data-id="element-116" data-mp="268g1g0kqgilk">
                <span className="block font-display text-2xl font-extrabold text-violeta-300 sm:text-3xl" data-id="element-117" data-mp="267wiqhn9dq6h">
                  {stat.value}
                </span>
                <span className="mt-1 block text-xs leading-snug text-violeta-100/70" data-id="element-118" data-mp="2fyr6jqg5kxu1">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </header>;
}